import CustomerNewOrder from '../../components/new-order/customer';
import NewCustomerRegister from '../../components/new-order/customer/components/new-customer';
import ServiceNewOrder from '../../components/new-order/service';
import styles from './NewOrder.module.css';
import React, { useCallback, useEffect, useState } from 'react';
import { InitialNewOrder } from './initial';
import EditCustomerRegister from '../../components/new-order/customer/components/edit-customer';
import DriverNewOrder from '../../components/new-order/driver';
import PickupNewOrder from '../../components/new-order/pickup';
import { useDispatch, useSelector } from 'react-redux';
import { Add_dropoff, Remove_dropoff, ResetNewOrder, Set_ActivePickupDropOff, SetDriverListOpenDialoge } from '../../Redux/actions/actionNames';
import DeliveryNewOrder from '../../components/new-order/delivery';
import DeliveryContainers from '../../components/new-order/deliveryContainers';
import MapNewOrderSelectPin from '../../components/shared/Map-NewOrder-Select-pin';
import AddressbookNewOrder from '../../components/new-order/addressBook/index';
import FooterNewOrder from '../../components/new-order/footer';
import CanSaveOrder from '../../components/new-order/canSaveOrder';
import CalculatePrice from '../../components/new-order/calculatePrice';
import Others from '../../components/new-order/other';
import Voip from '../../Entries/Voip';
import { useCSSTOTEXT } from '../../hooks/useCSSTOTEXT';
import { NewOrderEstimate } from '../../components/new-order/estimate-path-time';
import { MapContainer } from '../../components/shared/map-container';
import { MapNewOrderPinOnMap } from '../../components/shared/Map-NewOrder-pin-onMap';
import { useMapContainerWidthHeight } from '../../hooks/useMapContainerWidthHeight';
import { InitialMain } from '../shared/initial-main';
import StatusNewOrder from '../../components/new-order/status';
import { DriverList } from '../../components/main/driver-list';
import { RouteListMonitoring } from '../../components/route-details/monitoring';
import { Monitoring } from '../../components/main/moitoring';
import { deli_es, DRIVER_COLOR, PLUS, serv_es } from '../../assets';
import { useTranslation } from 'react-i18next';
import Typography from '../../design-system/lib/Typography';
import ServicePoint from '../../components/new-order/servicePoint';
import HeaderNewOrder from '../../components/new-order/header';
import { LearnMore } from '../../components/learnMore';
import Button from '../../design-system/lib/Button';
import history from '../../service/history';

 import BookColor from '../../assets/BookColor.svg';


export const NewOrderLayout = ({ mapWidth, sidebarIsOpen }) => {
  const [loaded, setLoaded] = useState(true);
  const [idArrays, setIdArrays] = useState([]);
  const [dropoffs, setDropoffs] = useState([]);
  const orderTypeActive = useSelector((state) => state.NewOrder.newOrder.orderTypeActive)
  const rebuildNewOrder = useSelector((state) => state.NewOrder.rebuildNewOrder)
  const MapContainerWidth = useMapContainerWidthHeight();
  const mainLoaded = useSelector((state) => state.SharedData.mainLoaded)
  const { t } = useTranslation();
  const deliveryMethod = useSelector((state) => state.NewOrder.newOrder.deliveryMethod)
  const ordersListOpen = useSelector((state) => state.SharedData.ordersListOpen)
  const editCustomerIsOpen = useSelector((state) => state.NewOrder.newOrder.editCustomerIsOpen)
  const newCustomerIsOpen = useSelector((state) => state.NewOrder.newOrder.newCustomer.open)
  const auto_suggestListData = useSelector((state) => state.NewOrder.newOrder.driver.auto_driver.auto_suggestListData)
  const auto_suggestListLoading = useSelector((state) => state.NewOrder.newOrder.driver.auto_driver.auto_suggestListLoading)

   let CSSTOTEXT = useCSSTOTEXT()

  const dispatch = useDispatch();

  const handleCollapse = React.useCallback((id) => {
    dispatch(Set_ActivePickupDropOff(id));
  }, [idArrays]);

  const setId = React.useCallback((id) => {


  }, [idArrays]);


  const addDropOff = React.useCallback(() => {
    dispatch(Add_dropoff(idgenerator()));

  }, []);

  const idgenerator = React.useCallback(() => {
    var number = Math.random(); // 0.9394456857981651
    number.toString(36); // '0.xtis06h6'
    var id = number.toString(36).substr(2, 9); // 'xtis06h6'
    return id.toString();
  }, []);


  const removeDropOff = React.useCallback((id) => {
    dispatch(Remove_dropoff(id));

  }, []);

  useEffect(() => {
    InitialNewOrder((call) => {
      setLoaded(call)
    })
  }, []);

  // useEffect(() => {
  //   if (rebuildNewOrder) {
  //     setTimeout(() => {
  //       dispatch(ResetNewOrder())
  //     }, 200);
  //   }

  // }, [rebuildNewOrder]);



  function mapOnCenterChange(value) {

  }


  let defaultMapStyle = MapContainerWidth


  if (loaded || mainLoaded) {
    return <div
      className={styles.App}
    > <div className={styles.newOrderContainer} style={{ marginInlineStart: ordersListOpen ? "" : "-465px", transition: "300ms all ease-in-out" }}>

        {(loaded && !rebuildNewOrder) ? <>

          <HeaderNewOrder />


          <div className={styles.newOrderInnerContainer}>
            <ServiceNewOrder />

            {(deliveryMethod && (["Delivery", "Pickup", "Ondemand"].indexOf(
              orderTypeActive
            ) > -1 ? auto_suggestListData?.length > 0 : true)) && <>
                <CustomerNewOrder />
              
                <ServicePoint />
                <DeliveryContainers handleCollapse={handleCollapse} orderTypeActive={orderTypeActive}
                  removeDrop={removeDropOff} addDropOff={addDropOff} />
                    {(["Delivery", "Pickup", "Ondemand"].indexOf(
                  orderTypeActive
                ) > -1 && auto_suggestListData?.length > 0) && <DriverNewOrder />}
              </>}
            {!deliveryMethod && <div className={styles.comtainer}>
              <img src={serv_es} style={{ width: "100%" }} />

              <div style={{ width: "256px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "6px" }}>
                <span style={{ fontSize: "16px", fontWeight: "700", color: "rgba(36, 36, 36, 1)", textAlign: "center" }}>{t("Add Delivery method")}</span>
                <span style={{ fontSize: "12px", fontWeight: "400", color: "rgba(128, 128, 128, 1)", textAlign: "center" }}>{t("Add your delivery method, then link your service to your delivery method")}</span>

                <div style={{ width: "256px", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "10px", marginTop: "4px" }}>
                  {/* <LearnMore where={"OndemandOrderList"} hastext={true} placement={"bottomStart"} className={styles.LearnMore} /> */}
                  <Button onClick={() => {
                    window.location.replace(`${window.location.origin}/admin/setting/operation-setup/delivery-methods/list`);

                  }} size='Medium' type='Primary' icon={PLUS} text={t('new')} style={{ padding: "9px 16px 9px 8px" }} />

                </div>
                <div style={{ width: "256px", height: "1px", backgroundColor: "rgb(224 224 224)", marginTop: "4px" }} />
                <span onClick={() => {
                  window.location.replace(`https://help.onro.io/en/articles/11151435-how-to-create-a-new-deliver-y-method`);

                }} style={{ gap: "6px", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginTop: "4px", cursor: "pointer" }}><img src={BookColor} style={{ width: "16px" }} />
                  <span style={{ fontSize: "14px", fontWeight: "500", color: "rgba(36, 36, 36, 1)", textAlign: "center" }}>How to create a new delivery method?</span>

                </span>
              </div>

            </div>
            }

             { (deliveryMethod && (["Delivery", "Pickup", "Ondemand"].indexOf(
              orderTypeActive
            ) > -1 ? auto_suggestListData?.length == 0 : false) && !auto_suggestListLoading) && <div className={styles.comtainer}>
              <img src={serv_es} style={{ width: "100%" }} />

              <div style={{ width: "256px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "6px" }}>
                <span style={{ fontSize: "16px", fontWeight: "700", color: "rgba(36, 36, 36, 1)", textAlign: "center" }}>{t("Add Vehicles")}</span>
                <span style={{ fontSize: "12px", fontWeight: "400", color: "rgba(128, 128, 128, 1)", textAlign: "center" }}>{t("Add vehicles for the service in admin center to be able to create order")}</span>

                <div style={{ width: "256px", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "10px", marginTop: "4px" }}>
                  {/* <LearnMore where={"OndemandOrderList"} hastext={true} placement={"bottomStart"} className={styles.LearnMore} /> */}
                  <Button onClick={() => {
                    window.location.replace(`${window.location.origin}/admin/setting/operation-setup/delivery-methods/list`);

                  }} size='Medium' type='Primary' icon={PLUS} text={t('new')} style={{ padding: "9px 16px 9px 8px" }} />

                </div>
                <div style={{ width: "256px", height: "1px", backgroundColor: "rgb(224 224 224)", marginTop: "4px" }} />
                <span onClick={() => {
                  window.location.replace(`https://help.onro.io/en/articles/10285146-how-to-create-a-new-vehicle-type`);

                }} style={{ gap: "6px", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginTop: "4px", cursor: "pointer" }}><img src={BookColor} style={{ width: "16px" }} />
                  <span style={{ fontSize: "14px", fontWeight: "500", color: "rgba(36, 36, 36, 1)", textAlign: "center" }}>How to create a new vehicle type?</span>

                </span>
              </div>

            </div>
            }
          </div>

          {(deliveryMethod && (["Delivery", "Pickup", "Ondemand"].indexOf(
              orderTypeActive
            ) > -1 ? auto_suggestListData?.length > 0 : true)) && <>
            {newCustomerIsOpen && <NewCustomerRegister />}
            {editCustomerIsOpen && <EditCustomerRegister />}
            <AddressbookNewOrder />
            <FooterNewOrder />
            <CanSaveOrder />
            <CalculatePrice />
          </>}






        </> : <span class="loader2"></span>}
        <Voip />


      </div>

      {["Ondemand"].indexOf(
        orderTypeActive
      ) == -1 && <div className={styles.monitoringEsContainer} style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "24px" }}>
          <NewOrderEstimate />
        </div>}

      {/* {(loaded && !rebuildNewOrder) && <MapNewOrderSelectPin FORCE={true} />} */}
      {/* {loaded && <MapContainer customBounds={null} style={{ width: "calc(100vw - 466px)", height: "100vh", zIndex: "5", position: "relative" }} className={styles.mainMapContainer} onCenterChange={mapOnCenterChange} >
        <Monitoring force={true} />

        <MapNewOrderPinOnMap />
      </MapContainer>} */}
      {/* <DriverList className={styles.driversList} style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: "0px" }} /> */}
      {["Ondemand"].indexOf(
        orderTypeActive
      ) > -1 && <div className={styles.monitoringContainer} style={{ [`${CSSTOTEXT["--main-inverseDefaultFloat"]}`]: `calc(${sidebarIsOpen ? `calc(${mapWidth} - 80px)` : mapWidth} - 230px)`, bottom: "18px" }}>
          <RouteListMonitoring showOrders={true} />
        </div>}

      {/* {["Ondemand"].indexOf(
        orderTypeActive
      ) > -1 && <div className={(Globalsettings && Globalsettings.dispatcherHomeMessage && String(Globalsettings.dispatcherHomeMessage).length > 0) ? styles.driversBtnToggle2 :styles.driversBtnToggle} onClick={() => { dispatch(SetDriverListOpenDialoge(true)) }}>
          <img src={DRIVER_COLOR} />
          <Typography text={t("Drivers")} weight='Body_Middle_Bold' style={{ color: "rgba(72, 72, 72, 1)" }} />
        </div>} */}

    </div>
  } else {
    return <div style={{ float: "left", marginLeft: "calc(50vw - 40px)", marginTop: 'calc(50vh - 40px)' }}>
      <div class="bodyx changingCssAnimation changingCssAnimationxx">
        <div class="boxes" >
          <div class="box">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div class="box">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div class="box">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div class="box">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

      </div>
    </div>


  }
}



